(function($) {

    $.fn.contentOperations = function() {

        this.each(function() {
            const $container = $(this);

            const $form = $container.find('form');

            // 連投防止: コメント編集 (POST /<slug>/topic/<N>/<M>/modify) の「変更を保存」には
            // 新規投稿フォーム (comment-form.js) のような多重送信ガードが無く、応答遅延中に連打
            // されると編集 POST が積み上がり、各リクエストが forum 単位ロック
            // (CommentModificationForm::save の withLocking) を保持したまま DB 接続を食い潰す
            // (連投で RDS 接続数が枯渇したインシデントの直接原因)。
            //
            // 送信自体は止めず、保存ボタンを無効化して2回目以降のクリック/Enter を弾く。
            // submit を return false で止めてはいけない: このフォームは enableClientValidation:false だが
            // validateOnSubmit は既定 true なので、yii.activeForm が1回目の submit を preventDefault し
            // ($form.on('submit.yiiActiveForm', submitForm))、検証後に $form.submit() で再 submit する
            // 二段構えで動く。return false はその再 submit (=本来の送信) まで弾いて編集が保存できなくなる。
            // ボタン無効化はプログラム submit ($form.submit()) を妨げないので再 submit はそのまま通る。
            // 成功時は POST→302 でページ遷移し無効化はリセット。応答が返らない間は無効化したまま
            // (= これ以上積まない)。再試行はページ再読込で行う。
            // contentOperations は comment/topic/tag/forum の編集フォーム共通で呼ばれる。
            // 無効化(連投防止)は全てに適用するが、「保存中…」インジケータはコメント編集のみに出す
            // (.comment-detail。約4秒かかる反映待ちの可視化。出すフォームのボタンには min-width で幅固定)。
            $form.on('submit', function () {
                var $submit = $form.find('.submit').addClass('disabled').prop('disabled', true);
                if ($container.hasClass('comment-detail')) {
                    $submit.html('<i class="fa-solid fa-spinner fa-spin"></i> 保存中…');
                }
            });

            // ソース表示
            $container.find('#show-content-source').on('change', function(){
                if ($(this).prop('checked')) {
                    $container.find('.body').hide();

                    const sourceContainer = $form.find('>.source-field');
                    sourceContainer.find('textarea').attr('readonly', true).css({
                        backgroundColor: '#fff',
                        cursor: 'text'
                    });
                    sourceContainer.find('input').attr('disabled', true).css({
                        backgroundColor: '#fff',
                        cursor: 'text'
                    });

                    $form.find('>*').not(sourceContainer).hide();
                    $container.find('.source').show();
                } else {
                    $container.find('.source').hide();
                    $container.find('.body').show();
                }
            });

            // 編集
            $container.find('#modify-content').on('click', function() {
                $container.children('.content').trigger('modify-content-on');
                $container.find('.body').each(function(){
                    const self = $(this);
                    if (self.closest('.markdown-toolbox-dialog-preview').length === 0) {
                        self.hide();
                    }
                });
                $container.find('.source').show();
                $(this).addClass('disabled');
            }).css({
                outline: 'none'
            });

            $container.find('#content-modification-cancel').on('click', function() {
                $container.children('.content').trigger('modify-content-off');
                $container.find('.body').show();
                $container.find('.source').hide();
                $container.find('#modify-content').removeClass('disabled');
            }).css({
                outline: 'none'
            });
        });
    };
})(jQuery);
